define([
	"dojo/_base/declare",
	"csi/tabs/View",
	"csi/util"
], function(declare,View,util) {

	return declare(View, {
		// Boolean: indicates if the finish button should be available on every page
		bShowFinishButton: false,

		constructor: function(def) {
			this.bShowFinishButton = Boolean(Number(util.getProperty(def,"ShowFinishButton",0)));
		}
	});
});